import { CURSOS } from '../models/CursoModel'

export const ESTADOS: { [key: string]: { nome: string; hifenizado: string; url: string } } = {
  AC: { nome: 'Acre', hifenizado: 'acre', url: 'https://newdriver.com.br/acre' },
  AL: { nome: 'Alagoas', hifenizado: 'alagoas', url: 'https://newdriver.com.br/alagoas' },
  AM: { nome: 'Amazonas', hifenizado: 'amazonas', url: 'https://newdriver.com.br/amazonas' },
  AP: { nome: 'Amapá', hifenizado: 'amapa', url: 'https://newdriver.com.br/amapa' },
  BA: { nome: 'Bahia', hifenizado: 'bahia', url: 'https://newdriver.com.br/bahia' },
  CE: { nome: 'Ceará', hifenizado: 'ceara', url: 'https://newdriver.com.br/ceara' },
  DF: {
    nome: 'Distrito Federal',
    hifenizado: 'distrito-federal',
    url: 'https://newdriver.com.br/distrito-federal',
  },
  ES: {
    nome: 'Espírito Santo',
    hifenizado: 'espirito-santo',
    url: 'https://newdriver.com.br/espirito-santo',
  },
  GO: { nome: 'Goiás', hifenizado: 'goias', url: 'https://newdriver.com.br/goias' },
  MA: { nome: 'Maranhão', hifenizado: 'maranhao', url: 'https://newdriver.com.br/maranhao' },
  MG: {
    nome: 'Minas Gerais',
    hifenizado: 'minas-gerais',
    url: 'https://newdriver.com.br/minas-gerais',
  },
  MT: {
    nome: 'Mato Grosso',
    hifenizado: 'mato-grosso',
    url: 'https://newdriver.com.br/mato-grosso',
  },
  MS: {
    nome: 'Mato Grosso do Sul',
    hifenizado: 'mato-grosso-do-sul',
    url: 'https://newdriver.com.br/mato-grosso-do-sul',
  },
  PA: { nome: 'Pará', hifenizado: 'para', url: 'https://newdriver.com.br/para' },
  PB: { nome: 'Paraíba', hifenizado: 'paraiba', url: 'https://newdriver.com.br/paraiba' },
  PE: {
    nome: 'Pernambuco',
    hifenizado: 'pernambuco',
    url: 'https://www.newdriver.com.br/pernambuco',
  },
  PI: { nome: 'Piauí', hifenizado: 'piaui', url: 'https://newdriver.com.br/piaui' },
  PR: { nome: 'Paraná', hifenizado: 'parana', url: 'https://newdriver.com.br/parana' },
  RJ: {
    nome: 'Rio de Janeiro',
    hifenizado: 'rio-de-janeiro',
    url: 'https://newdriver.com.br/rio-de-janeiro',
  },
  RN: {
    nome: 'Rio Grande do Norte',
    hifenizado: 'rio-grande-do-norte',
    url: 'https://newdriver.com.br/rio-grande-do-norte',
  },
  RO: { nome: 'Rondônia', hifenizado: 'rondonia', url: 'https://newdriver.com.br/rondonia' },
  RR: { nome: 'Roraima', hifenizado: 'roraima', url: 'https://newdriver.com.br/roraima' },
  RS: {
    nome: 'Rio Grande do Sul',
    hifenizado: 'rio-grande-do-sul',
    url: 'https://newdriver.com.br/rio-grande-do-sul',
  },
  SC: {
    nome: 'Santa Catarina',
    hifenizado: 'santa-catarina',
    url: 'https://newdriver.com.br/santa-catarina',
  },
  SE: { nome: 'Sergipe', hifenizado: 'sergipe', url: 'https://newdriver.com.br/sergipe' },
  SP: { nome: 'São Paulo', hifenizado: 'sao-paulo', url: 'https://newdriver.com.br/sao-paulo' },
  TO: { nome: 'Tocantins', hifenizado: 'tocantins', url: 'https://newdriver.com.br/tocantins' },
}

export enum ETAPAS {
  CURSO = 0,
  DADOS_ALUNO = 1,
  CONTATO = 2,
  PAGAMENTO = 3,
  SUCESSO = 4,
}

// prettier-ignore
export const reciclagem = [
  { id: CURSOS.ATUALIZACAO_RENOVACAO_CNH, nome: 'Atualização para Renovação da CNH', urlSlug: 'atualizacao-para-renovacao' },
  { id: CURSOS.RECICLAGEM, nome: 'Reciclagem para condutores infratores', urlSlug: 'reciclagem-para-condutores-infratores' },
  { id: CURSOS.PREVENTIVO_RECICLAGEM, nome: 'Preventivo de Reciclagem', urlSlug: 'preventivo-de-reciclagem' },
]
// prettier-ignore

// prettier-ignore
export const especializacao = [
  { id: CURSOS.ESCOLAR, nome: 'Condutores de transporte escolar', urlSlug: 'condutores-de-transporte-escolar', urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-escolar' },
  { id: CURSOS.EMERGENCIA, nome: 'Condutores de transporte de emergência', urlSlug: 'condutores-de-transporte-de-emergencia', urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-emergencia' },
  { id: CURSOS.CARGA_INDIVISIVEL, nome: 'Condutores de cargas indivisíveis', urlSlug: 'condutores-de-transporte-de-cargas-indivisiveis', urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-cargas-indivisiveis' },
  { id: CURSOS.PRODUTOS_PERIGOSOS, nome: 'Condutores de transporte de produtos perigosos', urlSlug: 'condutores-de-transporte-de-produtos-perigosos', urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-produtos-perigosos' },
  { id: CURSOS.COLETIVO_DE_PASSAGEIROS, nome: 'Condutores de transporte coletivo de passageiros', urlSlug: 'condutores-de-transporte-coletivo-de-passageiros', urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-coletivo-de-passageiros' },
  { id: CURSOS.MOTOTAXISTA, nome: 'Mototaxi', urlSlug: 'mototaxi', urlSlugCapacitacao: 'especializado-para-mototaxista' },
  { id: CURSOS.MOTOFRETISTA, nome: 'Motofrete', urlSlug: 'motofrete', urlSlugCapacitacao: 'especializado-para-motofretista' },
]
// prettier-ignore

// prettier-ignore
export const atualizacao = [
  { id: CURSOS.ATUALIZACAO_ESCOLAR, nome: 'Condutores de transporte escolar', urlSlug: 'condutores-de-transporte-escolar', urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-escolar' },
  { id: CURSOS.ATUALIZACAO_EMERGENCIA, nome: 'Condutores de transporte de emergência', urlSlug: 'condutores-de-transporte-de-emergencia', urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-emergencia' },
  { id: CURSOS.ATUALIZACAO_CARGA_INDIVISIVEL, nome: 'Condutores de cargas indivisíveis', urlSlug: 'condutores-de-transporte-de-cargas-indivisiveis', urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-cargas-indivisiveis' },
  { id: CURSOS.ATUALIZACAO_PRODUTOS_PERIGOSOS, nome: 'Condutores de transporte de produtos perigosos', urlSlug: 'condutores-de-transporte-de-produtos-perigosos', urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-produtos-perigosos' },
  { id: CURSOS.ATUALIZACAO_COLETIVO_DE_PASSAGEIROS, nome: 'Condutores de transporte coletivo de passageiros', urlSlug: 'condutores-de-transporte-coletivo-de-passageiros', urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-coletivo-de-passageiros' },
  { id: CURSOS.ATUALIZACAO_MOTOTAXISTA, nome: 'Mototaxi', urlSlug: 'mototaxi', urlSlugAtualizacao: 'atualizacao-para-mototaxista' },
  { id: CURSOS.ATUALIZACAO_MOTOFRETISTA, nome: 'Motofrete', urlSlug: 'motofrete', urlSlugAtualizacao: 'atualizacao-para-motofretista' },
]
// prettier-ignore

export const cursosSlug: {
  nome: string,
  urlSlug: string,
  idCapacitacao: CURSOS,
  idAtualizacao?: CURSOS,
  urlSlugCapacitacao: string,
  urlSlugAtualizacao?: string,
}[] = [
  {
    nome: 'Reciclagem para Condutores Infratores',
    urlSlug: 'reciclagem-para-condutores-infratores',
    urlSlugCapacitacao: 'reciclagem-para-condutores-infratores',
    idCapacitacao: CURSOS.RECICLAGEM,
  },
  {
    nome: 'Preventivo de Reciclagem',
    urlSlug: 'preventivo-de-reciclagem',
    urlSlugCapacitacao: 'preventivo-de-reciclagem',
    idCapacitacao: CURSOS.PREVENTIVO_RECICLAGEM,
  },
  {
    nome: 'Atualização para Renovação',
    urlSlug: 'atualizacao-para-renovacao',
    urlSlugCapacitacao: 'atualizacao-para-renovacao',
    idCapacitacao: CURSOS.ATUALIZACAO_RENOVACAO_CNH,
  },
  {
    nome: 'Mototaxi',
    urlSlug: 'mototaxi',
    urlSlugCapacitacao: 'especializado-para-mototaxista',
    urlSlugAtualizacao: 'atualizacao-para-mototaxista',
    idCapacitacao: CURSOS.MOTOTAXISTA,
    idAtualizacao: CURSOS.ATUALIZACAO_MOTOTAXISTA,
  },
  {
    nome: 'Motofrete',
    urlSlug: 'motofrete',
    urlSlugCapacitacao: 'especializado-para-motofretista',
    urlSlugAtualizacao: 'atualizacao-para-motofretista',
    idCapacitacao: CURSOS.MOTOFRETISTA,
    idAtualizacao: CURSOS.ATUALIZACAO_MOTOFRETISTA,
  },
  {
    nome: 'Direção Defensiva',
    urlSlug: 'direcao-defensiva',
    urlSlugCapacitacao: 'direcao-defensiva',
    idCapacitacao: CURSOS.DIRECAO_DEFENSIVA,
  },
  {
    nome: 'Condutores de Transporte Coletivo de Passageiros',
    urlSlug: 'condutores-de-transporte-coletivo-de-passageiros',
    urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-coletivo-de-passageiros',
    urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-coletivo-de-passageiros',
    idCapacitacao: CURSOS.COLETIVO_DE_PASSAGEIROS,
    idAtualizacao: CURSOS.ATUALIZACAO_COLETIVO_DE_PASSAGEIROS,
  },
  {
    nome: 'Condutores de Transporte de Produtos Perigosos',
    urlSlug: 'condutores-de-transporte-de-produtos-perigosos',
    urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-produtos-perigosos',
    urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-produtos-perigosos',
    idCapacitacao: CURSOS.PRODUTOS_PERIGOSOS,
    idAtualizacao: CURSOS.ATUALIZACAO_PRODUTOS_PERIGOSOS,
  },
  {
    nome: 'Condutores de Transporte de Cargas Indivisíveis',
    urlSlug: 'condutores-de-transporte-de-cargas-indivisiveis',
    urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-cargas-indivisiveis',
    urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-cargas-indivisiveis',
    idCapacitacao: CURSOS.CARGA_INDIVISIVEL,
    idAtualizacao: CURSOS.ATUALIZACAO_CARGA_INDIVISIVEL,
  },
  {
    nome: 'Condutores de Transporte de Emergência',
    urlSlug: 'condutores-de-transporte-de-emergencia',
    urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-de-emergencia',
    urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-de-emergencia',
    idCapacitacao: CURSOS.EMERGENCIA,
    idAtualizacao: CURSOS.ATUALIZACAO_EMERGENCIA,
  },
  {
    nome: 'Condutores de Transporte Escolar',
    urlSlug: 'condutores-de-transporte-escolar',
    urlSlugCapacitacao: 'especializado-para-condutores-de-transporte-escolar',
    urlSlugAtualizacao: 'atualizacao-para-condutores-de-transporte-escolar',
    idCapacitacao: CURSOS.ESCOLAR,
    idAtualizacao: CURSOS.ATUALIZACAO_ESCOLAR,
  },
]
